import * as React from 'react';
import { connect } from 'react-redux';
import { productInfoDeferred } from '../actions/Actions';
import { IProductInfo, IUserInfo } from '../CustomTypes';

export interface IRecheckit {
  productInfo: IProductInfo;
  userInfo: IUserInfo;
}

export class Recheckit extends React.Component<IRecheckit, {}> {
  public componentDidMount() {
    productInfoDeferred.promise.then(product => {
      if (this.isRechekitEnabled(product)) {
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute(
          'src',
          `https://d2df291ti5v5sq.cloudfront.net/rc/${
            product.rckPathId
          }/scripts/s.js`
        );
        script.id = 'd2df291ti5v5sq';
        document.body.appendChild(script);
      }
    });
  }

  public render() {
    const {
      productId,
      header,
      imageurl,
      text1,
      price,
      productCampaign,
      rckEnableFirstservice,
      rckEnableOnsite,
      productType
    } = this.props.productInfo;
    const { firstName, lastName, email } = this.props.userInfo;

    return (
      <div className="recheckit">
        {this.isRechekitEnabled(this.props.productInfo) && (
          <div>
            <input
              type="hidden"
              id="rckEnableFirstservice"
              value={'' + rckEnableFirstservice}
            />
            <input
              type="hidden"
              id="rckEnableOnsite"
              value={'' + rckEnableOnsite}
            />
            <input type="hidden" id="productImageUrl" value={imageurl} />
            <input type="hidden" id="productMobileImageUrl" value={imageurl} />
            <input type="hidden" id="productName" value={header} />
            <input type="hidden" id="productDescription" value={text1} />
            <input type="hidden" id="productId" value={productId} />
            <input type="hidden" id="productCampaign" value={productCampaign} />
            <input type="hidden" id="productPrice" value={price} />
            <input type="hidden" id="productType" value={productType} />
            <input type="hidden" id="receiverEmail" value={email} />
            <input type="hidden" id="receiverFirstname" value={firstName} />
            <input type="hidden" id="receiverLastname" value={lastName} />
          </div>
        )}
      </div>
    );
  }

  private isRechekitEnabled(product: IProductInfo): boolean {
    return product.rckEnableFirstservice || product.rckEnableOnsite;
  }
}

export default connect(state => ({
  productInfo: state.productInfo,
  userInfo: state.userInfo
}))(Recheckit);



// WEBPACK FOOTER //
// ./src/layout-components/Recheckit.tsx